require('./scheduledTransfersOptionsButtons.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
//@constants
const INVALID_PRODUCT_NUMBER = '696';
//@ actions
const scheduledTransfersDetailsActions = require('actions/scheduledTransfersDetails');

class ScheduledTransfersOptionsButtons extends React.Component {
    constructor(props) {
        super(props);

        this.buildEditButton = this.buildEditButton.bind(this);
        this.buildTrashButton = this.buildTrashButton.bind(this);
        this.handleRowButtons = this.handleRowButtons.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    handleRedirect(url) {
        this.props.history.push(url);
    }

    handleRowButtons(url) {
        const { getScheduledTransfersDetails, immTransaction } = this.props;
        const accountId = immTransaction.get('accountId');
        const scheduledTransfersId = immTransaction.get('id');

        if (!!immTransaction.get('details')) {
            this.handleRedirect(url);
        } else {
            getScheduledTransfersDetails(accountId, scheduledTransfersId, this.handleRedirect, url);
        }
    }

    buildEditButton(accountId, scheduledId, disabled, isFetchingDetails, isMobile) {
        const editScheduledTransferLink = `/myprofile/transfers/scheduled/${accountId}/${scheduledId}/edit`;
        const tooltipText = disabled ? <FormattedText value="transfersScheduled-invalidProductMessage" /> : <FormattedText value="editScheduledTransfer-modify" />;
        const modifyButtonClasses = classNames(
            'scheduled-transfers-options-buttons__button-container',
            {'scheduled-transfers-options-buttons__button-container--no-margin-left': isMobile}
        );

        const modifyButton = (
            <div className={modifyButtonClasses}>
                <OKButton
                    disabled={disabled}
                    loaderColor="dark"
                    loaderSize="small"
                    loading={isFetchingDetails}
                    modifier="task"
                    onClick={() => this.handleRowButtons(editScheduledTransferLink)}
                    size="small"
                >
                    <i className="icon-s-editar" />
                </OKButton>
            </div>
        );
        return (
            <OKTooltip
                content={tooltipText}
                offset={[0, -15]}
                target={modifyButton}
                type="descriptive"
            />
        );
    }

    buildTrashButton(accountId, scheduledId, disabled, isFetchingDetails) {
        const removeScheduledTransferLink = `/myprofile/transfers/scheduled/${accountId}/remove/${scheduledId}`;
        const tooltipText = disabled ? <FormattedText value="transfersScheduled-invalidProductMessage" /> : <FormattedText value="editScheduledTransfer-cancel" />;
        const trashButton = (
            <div className="scheduled-transfers-table-row__actions__button-container" >
                <OKButton
                    disabled={disabled}
                    loaderColor="dark"
                    loaderSize="small"
                    loading={isFetchingDetails}
                    modifier="task"
                    onClick={() => this.handleRowButtons(removeScheduledTransferLink)}
                    size="small"
                >
                    <i className="icon-eliminar scheduled-transfers-table-row__delete-icon" />
                </OKButton>
            </div>
        );
        return (
            <OKTooltip
                content={tooltipText}
                offset={[0, -15]}
                target={trashButton}
                type="descriptive"
            />
        );
    }

    isEditDisabled(accountId) {
        const {
            immAccounts,
            immTransaction
        } = this.props;

        const immAccount = immAccounts.get('byId').get(accountId);
        const isInactiveAccount = immAccount.get('isInactiveAccount');
        const productNumber = immTransaction.getIn(['extra', 'product']);

        if( isInactiveAccount || (productNumber === INVALID_PRODUCT_NUMBER) ) {
            return true;
        }

        return false;
    }

    render() {
        const {
            immTransaction,
            isMobile,
        } = this.props;

        const accountId = immTransaction.get('accountId');
        const scheduledId = immTransaction.get('id');
        const editDisabled = this.isEditDisabled(accountId);
        const deleteDisabled = (immTransaction.getIn(['extra', 'product']) === INVALID_PRODUCT_NUMBER);
        const isFetchingDetails = immTransaction.getIn(['fetchingDetails']);
        const editButton = this.buildEditButton(accountId, scheduledId, editDisabled, isFetchingDetails, isMobile);
        const deleteButton = this.buildTrashButton(accountId, scheduledId, deleteDisabled, isFetchingDetails);

        return (
            <React.Fragment>
                {editButton}
                {deleteButton}
            </React.Fragment>
        );
    }
}

ScheduledTransfersOptionsButtons.propTypes = {
    getScheduledTransfersDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immTransaction: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
};

ScheduledTransfersOptionsButtons.defaultProps = {
    isMobile: false,
};

module.exports.constructor = ScheduledTransfersOptionsButtons;
module.exports = connect(state => ({
        immAccounts: state.accounts
    }),
    {
        getScheduledTransfersDetails: scheduledTransfersDetailsActions.getScheduledTransfersDetails,
    })(withRouter(ScheduledTransfersOptionsButtons));
